/**
 * 医院等级
 * @type {*[]}
 */
export const HOSPITAL_LEVEL = [
  {id: '30', value: '三级特等'},
  {id: '31', value: '三级甲等'},
  {id: '32', value: '三级乙等'},
  {id: '33', value: '三级丙等'},
  {id: '21', value: '二级甲等'},
  {id: '22', value: '二级乙等'},
  {id: '23', value: '二级丙等'},
  {id: '11', value: '一级甲等'},
  {id: '12', value: '一级乙等'},
  {id: '13', value: '一级丙等'},
  {id: '00', value: '暂无'},
]

export const docStyle = [
  {id: 'expert', value: '按专家预约'},
  {id: 'date', value: '按日期预约'}]

export const deptStates = [
  {0: '预约', 1: '已满', 2: '停诊', 3: '不挂号', 5: '未发布', 6: '删除'}
]
/**
 * 医生的排班状态
 * @type {*[]}
 */
export const doctStates = [
  {0: '未排班', 1: '停诊', 2: '已满', 3: '即将放号', 4: '预约'}
]

/**
 * 排班的状态
 * @type {{"0": string, "1": string, "2": string, "3": string}}
 */
export const numStates = { '0': '预约', '1': '停诊', '2': '已结束', '3': '已满', '4': '预约'}

/**
 * 排班页科室上下午排班状态
 * @type {{"0": string, "1": string, "2": string, "3": string}}
 */
export const paibanDeptStates = {'0': '预约', '1': '停诊', '2': '已结束', '3': '已满'}

export const bookType = [
  {
    type: 'order',
    title: '<span class="fs17">预约挂号</span>',
    content: '<span class="color_999 fs15">七天内普通号、专家号预约</span>'
  },
  {
    type: 'today',
    title: '<span class="fs17">当天挂号</span>',
    content: '<span class="color_999 fs15">当天号源立挂立取</span>'
  }
]



// WEBPACK FOOTER //
// ./src/lib/config/book.js